export default __webpack_public_path__ + "static/media/16.044b0708.png";